export enum URLParams {
  SEARCH = "search",
  CATEGORIES = "categories",
  DAYS = "days",
  COACHES = "coaches",
}
